import React from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

interface NotificationSnackbarProps {
    open: boolean;
    message: string;
    severity: 'success' | 'error';
    onClose: () => void;
    autoHideDuration?: number;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
    open,
    message,
    severity,
    onClose,
    autoHideDuration = 3000
}) => {
    const { t } = useTranslation();
    return (
        <Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
            <Alert onClose={onClose} severity={severity} elevation={6} variant="filled">
                {message}
            </Alert>
        </Snackbar>
    );
};

export default NotificationSnackbar;
